import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const TARGET = new Date("2027-12-26T00:00:00+05:30").getTime();

const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

const useCountdown = () => {
    const calc = () => {
        const diff = Math.max(0, TARGET - Date.now());
        return {
            days: Math.floor(diff / 86400000),
            hours: Math.floor(diff / 3600000) % 24,
            minutes: Math.floor(diff / 60000) % 60,
            seconds: Math.floor(diff / 1000) % 60,
        };
    };
    const [t, setT] = useState(calc);
    useEffect(() => {
        const id = setInterval(() => setT(calc()), 1000);
        return () => clearInterval(id);
    }, []);
    return t;
};

const Unit = ({ value, label }) => (
    <span className="inline-flex items-baseline gap-1">
        <span className="font-heading text-sm font-extrabold tabular-nums text-slate-900 sm:text-base">
            {value}
        </span>
        <span className="font-mono2 text-[8px] uppercase tracking-[0.2em] text-slate-400 sm:text-[9px]">
            {label}
        </span>
    </span>
);

export const Countdown = () => {
    const t = useCountdown();
    return (
        <motion.div
            data-testid="launch-countdown"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.5 }}
            className="inline-flex items-center gap-1.5 sm:gap-2"
        >
            <Unit value={pad(t.days)} label="d" />
            <span className="font-mono2 text-[10px] text-slate-300">:</span>
            <Unit value={pad(t.hours)} label="h" />
            <span className="font-mono2 text-[10px] text-slate-300">:</span>
            <Unit value={pad(t.minutes)} label="m" />
            <span className="font-mono2 text-[10px] text-slate-300">:</span>
            <Unit value={pad(t.seconds)} label="s" />
        </motion.div>
    );
};
